import { render, staticRenderFns } from "./invoice-setting.vue?vue&type=template&id=31222e00&scoped=true"
import script from "./invoice-setting.vue?vue&type=script&lang=js"
export * from "./invoice-setting.vue?vue&type=script&lang=js"
import style0 from "./invoice-setting.vue?vue&type=style&index=0&id=31222e00&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31222e00",
  null
  
)

export default component.exports